import { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import api from "@/lib/api";

// Shown only when the server reports the conditions as actually true (dev OTP echo and/or no outbound transport).
export function ShadowBanner() {
  const [flags, setFlags] = useState(null);
  useEffect(() => { api.get("/auth/environment").then((r) => setFlags(r.data)).catch(() => setFlags(null)); }, []);
  if (!flags) return null;
  const businessMailOn = Boolean(flags.comms_dispatch_worker_enabled || flags.graph_enabled);
  const outboundOff = !flags.email_transport_configured && !businessMailOn;
  const prov = flags.data_provenance || {};
  const isProd = flags.environment === "production";
  if (!flags.otp_dev_echo && !outboundOff && !prov.imported_legacy_records) return null;
  const label = isProd ? "Production - test mode" : "Isolated test environment";
  const dataText = prov.imported_legacy_records
    ? `Imported historical records from the previous portal (snapshot 17 September 2026; ${prov.imported_legacy_records.toLocaleString()} bookings). Historical records have no portal access and are read-only.${prov.synthetic_fixtures ? " Synthetic test fixtures are also present." : ""}`
    : "Synthetic test data only - do not enter real guest, client or supplier data.";
  return (
    <div data-testid="shadow-banner" role="status" className="mb-4 flex items-start gap-3 rounded-[10px] border border-amber-300 bg-amber-50 px-4 py-3 text-[13px] text-amber-900">
      <FlaskConical className="mt-0.5 h-4 w-4 shrink-0 text-amber-700" />
      <p className="space-x-1">
        <span className="font-semibold uppercase tracking-wide">{label}</span>
        <span data-testid="shadow-banner-data">- {dataText}</span>
        <span data-testid="shadow-banner-signin-mail">{flags.email_transport_configured ? "Sign-in codes are delivered by e-mail." : "No sign-in e-mail transport is configured."}</span>
        <span data-testid="shadow-banner-outbound">{businessMailOn ? "Business e-mail dispatch is enabled." : "Business e-mail dispatch is off."}</span>
        {flags.otp_dev_echo && <span data-testid="shadow-banner-otp">Sign-in codes are shown on screen (development echo).</span>}
      </p>
    </div>
  );
}
